import { render } from "./ExploreView.vue?vue&type=template&id=6f96f64d"
const script = {}
script.render = render

export default script